import {AttributeLink} from '@acng/frontend-stargazer';
import {Conditional} from '../service/conditional';
import {ConnectMatchMedia} from '@acng/frontend-bounty/cssom/media.js';

/**
 * @group DOM Attribute
 */
const name = 'if-media';

AttributeLink(name, (element, value) => ConnectMatchMedia(value, Conditional(element)));

export {name as IF_MEDIA};
